// AddFundsMenu.tsx — puts "Add funds" one tap away, OUTSIDE the account avatar's popover.
//
// Apple 2.1(b) (Focus/Gifted rejections, 2026-09-05): reviewers did not locate the wallet
// top-up when it lived only nested inside AccountMenu's own avatar popover. This renders
// WalletTopUp directly as soon as this control opens — no second tap on a nested avatar
// required. Same fix shape as Focus (a Settings screen) / Gifted (a drawer); this app has
// neither, so it gets its own small, clearly-labeled control next to AccountMenu.
//
// iOS/MAS only — Apple IAP doesn't apply on other desktop builds, so the control simply
// doesn't render there (mirrors AccountMenu's own isIos/isMasMac gate).
import { useState } from "react";
import { platform } from "./tauri-web";
import { WalletTopUp } from "./iap";

export function AddFundsMenu() {
  const [open, setOpen] = useState(false);
  const isIos = platform() === "ios";
  const isMasMac = platform() === "macos" && (import.meta as any).env?.VITE_MAS === "1";
  if (!isIos && !isMasMac) return null;
  return (
    <div style={{ position: "relative" }}>
      <button
        type="button"
        className="btn"
        aria-label="Add funds"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
        style={{ fontSize: "var(--fs-xs)", fontWeight: 600 }}
      >
        Add funds
      </button>
      {open && (
        <>
          <div onClick={() => setOpen(false)} style={{ position: "fixed", inset: 0, zIndex: 40 }} />
          <div className="card" style={{ position: "absolute", right: 0, top: "calc(100% + 6px)", zIndex: 50, width: "min(260px, 88vw)", padding: "0.85rem", textAlign: "left" }}>
            <WalletTopUp />
          </div>
        </>
      )}
    </div>
  );
}
